// extracted by mini-css-extract-plugin
module.exports = {"title":"kids-module--title--JCS9B"};